module.exports = __webpack_public_path__ + "media/images/home/marketposter_cripto-6ee09076b0171994d7aebab094b8bb8c.png";